// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"25e1479f","455":"10e3d0b9","488":"4eb78c3b"}[chunkId] + ".chunk.js";
};